import { useTranslation } from "react-i18next";
import styles from "../../../styles/aprt.module.scss";

function AssetLoadError({ dataUrl, loadingErrorMessage }) {
  const { t } = useTranslation();

  const errorMessage = loadingErrorMessage || t("load_error_0");

  return (
    <div className={styles.svgPlan__frame}>
      <div className={styles.error__container}>
        <div className={styles.error__logo}>
          <img
            src={`${dataUrl}website/assets/project_logo.svg`}
            alt="logo"
            className="error__icon"
          />
        </div>
        <p className={styles.error__paragraph}>{errorMessage}</p>
      </div>
    </div>
  );
}

export default AssetLoadError;
